import { ReactNode, CSSProperties, HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  title?: string;
  style?: CSSProperties;
  className?: string;
}

export default function Card({ children, title, style, className, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={['acc-card', className].filter(Boolean).join(' ')}
      style={style}
    >
      {title && <div className="acc-card__title">{title}</div>}
      {children}
    </div>
  );
}
